
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-mentor",
      function () {
        return require("private-next-pages/become-a-mentor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-a-mentor"])
      });
    }
  